<template>
    <div
        class="col-span-12 border-gray-200 grid grid-cols-7 lg:grid-cols-13 gap-2"
    >
        <div class="flex col-span-7 md:col-span-2 items-center gap-1 md:gap-4">
            <FilterGroupDropdown
                btnLabel="Hotel Brand"
                class="col-span-1"
                :options="groups"
                labelKey="title"
                origin="favorites"
                :selected="selectedGroups"
                :showOptionImages="true"
                @selectionMade="setGroups"
                @clearSelected="resetGroupFilters"
            />

            <FavoritesNameSearch origin="map" />
        </div>
    </div>
</template>

<script>
import { computed } from 'vue';
import { useHotelsStore } from '@/store/hotels';
import { storeToRefs } from 'pinia';
import Filters from '@/filters';
import FavoritesNameSearch from '@/components/hotels/favorites/favorites-name-search/favorites-name-search.vue';
import FilterGroupDropdown from '@/components/ui/filter-group-dropdown/filter-group-dropdown.vue';
export default {
    components: {
        FavoritesNameSearch,
        FilterGroupDropdown,
    },
    setup() {
        const hotelsStore = useHotelsStore();
        const { selectedGroups, loading, usersFavHotels } =
            storeToRefs(hotelsStore);
        const { setGroups, clearSelectedGroups, setLoading } = hotelsStore;

        const groups = computed(() => {
            const flattenedFavs = Object.values(usersFavHotels.value).flat();

            return flattenedFavs.reduce((arr, property) => {
                const exists = arr.find((g) => g.name == property.group);
                if (!exists) {
                    arr.push({
                        name: property.group,
                        image: property.program?.image,
                        title: Filters.ucWords(property.group),
                    });
                }
                return arr;
            }, []);
        });

        const resetGroupFilters = () => {
            setLoading(true);
            clearSelectedGroups();
            setTimeout(() => {
                setLoading(false);
            }, 250);
        };

        return {
            setGroups,
            resetGroupFilters,
            selectedGroups,
            groups,
            loading,
            usersFavHotels,
        };
    },
};
</script>
